module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part_color"
  }, [_c('p', {
    staticClass: "PartNo",
    attrs: {
      "id": "p01"
    }
  }, [_vm._v("Part  "), _c('span', {
    staticClass: "txt_white"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "PartTitle",
    attrs: {
      "id": "pt01"
    }
  }, [_vm._v("The Method")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('i', [_vm._v("First things first—what is foundation paper piecing? How do you sew on paper? Do you need special tools?")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('i', [_vm._v("In this first section, I walk you through the method I’ve developed for all my paper-piecing escapades, covering everything you need to know to go from cryptic lines and numbers on paper to a finished fabric block.")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d69e27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_part01.vue
// module id = 72
// module chunks = 0